import { ExtranetContainer, useBreakpoint, useLanguage } from '@pharmac-extranet/shared'
import { PharmacLoadingDots } from '@pharmac/ui'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { useCustomerContext } from '../../features/customer/CustomerProvider'
import { api } from '../../services/HttpService'
import { ExtranetViewReturnButton } from '../extranet/ExtranetViewReturnButton'
import { ExtranetWrapper } from '../extranet/ExtranetWrapper'
import { ShopProductDocument } from './ShopProductDocument'
import { ShopProductVideo } from './ShopProductVideo'
import { useShop } from './useShop'

export const ShopProductView = () => {
  const { id } = useParams()
  const { customer } = useCustomerContext()
  const { minDesktop } = useBreakpoint()
  const { i18n } = useLanguage()
  const { langQuery } = useShop()

  const { data, isLoading } = useQuery({
    queryKey: ['__shopProducts', customer?.id, id],
    queryFn: async () =>
      await api.shop.getShopProductById(Number(customer?.id), Number(id as string), {
        language: langQuery(i18n.language),
      }),
    enabled: typeof id === 'string' && !isNaN(+id),
  })

  return (
    <ExtranetWrapper>
      <ExtranetContainer
        paddingSmallHorizontal
        paddingLargeVertical={minDesktop}
        paddingMediumVertical={!minDesktop}
        full
      >
        <ExtranetContainer>
          <ExtranetViewReturnButton />
        </ExtranetContainer>
      </ExtranetContainer>
      {isLoading && (
        <ExtranetContainer
          justifyCenter
          alignCenter
        >
          <PharmacLoadingDots />
        </ExtranetContainer>
      )}
      {data?.productFamily === 'recording-product' ? (
        <ShopProductVideo videoProduct={data} />
      ) : (
        data && <ShopProductDocument documentProduct={data} />
      )}
    </ExtranetWrapper>
  )
}
